import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { ToastType } from '@app/core/components/toast/toast.component';

@Component({
    selector: 'tt-vat-reports',
    templateUrl: './vat-reports.component.html',
    styleUrls: ['./vat-reports.component.css'],
})
export class VatReportsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListAccountingYears: AccountingYearItem[] = [];

    public grid?: GridOptions;

    constructor(
        private stateService: StateService,
        private datatask: DataTaskService,
        private logistic: LogisticService,
    ) {}

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3128))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadAccountingYears() {
        if (!this.setting) return;

        return (this.selectListAccountingYears = await this.datatask.Post(2820, { businessco_no: this.setting.businessco_no }));
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_vatreports_grid')
                .setLoadDataFunction({
                    method: 3129,
                    parameters: () => this.setting,
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([
                    {
                        name: 'vatreports_new',
                        text: 'vatreports_new',
                        tooltip: 'vatreports_new',
                        translateTooltip: true,
                        func: () => {
                            this.stateService?.go('vatreport', {
                                businessco_no: this.setting?.businessco_no,
                                accounting_year: this.setting?.accounting_year,
                                vatreport_keyno: '0',
                            });
                        },
                        icon: 'fas fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true,
                    },
                ]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                Promise.all([this.loadAccountingYears()]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'accounting_year':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();

        return Promise.all([this.loadAccountingYears()]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    accounting_year: string;
    type: ToastType;
    message: string;
}

interface AccountingYearItem {
    transyear: string;
    transyear_name: string;
    orderby: number;
}
